const accessibleChannel = [
  {
    id: 1,
    label: '無障礙坡道(圖書館前)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958034,121.240504',
    position: { lat: 24.958034, lng: 121.240504 },
    entry: { lat: 24.958034, lng: 121.240504 },
    path: './number/cycu-number-ROLL.svg',
  },
  {
    id: 2,
    label: '無障礙坡道(維澈樓旁)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957169,121.240654',
    position: { lat: 24.957169, lng: 121.240654 },
    entry: { lat: 24.957169, lng: 121.240654 },
    path: './number/cycu-number-ROLL.svg',
  },
  {
    id: 3,
    label: '無障礙坡道(產學大樓前)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956477,121.241967',
    position: { lat: 24.956477, lng: 121.241967 },
    entry: { lat: 24.956477, lng: 121.241967 },
    path: './number/cycu-number-ROLL.svg',
  },
  {
    id: 4,
    label: '無障礙坡道(電學大樓旁)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955815,121.242558',
    position: { lat: 24.955815, lng: 121.242558 },
    entry: { lat: 24.955815, lng: 121.242558 },
    path: './number/cycu-number-ROLL.svg',
  },
  {
    id: 5,
    label: '無障礙坡道(良善樓旁)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955638,121.242343',
    position: { lat: 24.955638, lng: 121.242343 },
    entry: { lat: 24.955638, lng: 121.242343 },
    path: './number/cycu-number-ROLL.svg',
  },
  {
    id: 6,
    label: '無障礙坡道(建築館旁)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955997,121.243460',
    position: { lat: 24.955997, lng: 121.243460 },
    entry: { lat: 24.955997, lng: 121.243460 },
    path: './number/cycu-number-ROLL.svg',
  },
  {
    id: 7,
    label: '無障礙坡道(莊敬大樓旁)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956481,121.244019',
    position: { lat: 24.956481, lng: 121.244019 },
    entry: { lat: 24.956481, lng: 121.244019 },
    path: './number/cycu-number-ROLL.svg',
  },
  {
    id: 8,
    label: '無障礙坡道(土木館旁)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956581,121.244538',
    position: { lat: 24.956581, lng: 121.244538 },
    entry: { lat: 24.956581, lng: 121.244538 },
    path: './number/cycu-number-ROLL.svg',
  },
];

export default accessibleChannel;
